/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 23, height = 23 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 23" fill="none">
    <path d="M21.1285 14.0108C22.8584 12.3157 24.6116 10.2838 24.6116 7.62503C24.6116 5.93142 23.9388 4.30717 22.7413 3.10961C21.5437 1.91204 19.9195 1.23926 18.2259 1.23926C16.1824 1.23926 14.7427 1.81978 13.0011 3.56136C11.2596 1.81978 9.81985 1.23926 7.7764 1.23926C6.08279 1.23926 4.45854 1.91204 3.26098 3.10961C2.06341 4.30717 1.39063 5.93142 1.39062 7.62503C1.39062 10.2954 3.1322 12.3273 4.87378 14.0108L13.0011 22.1382L21.1285 14.0108Z" stroke="#262626" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
